<template>

  <section class="index">
   <div class="container-fluid p-0">
      <div class="col-xs-12 titulo" :style="'background: url('+fondo+')'">
        <h2 class="pull-right">Eventos</h2>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-3 p-0 cats">
          <router-link :to="'/directorio/gastronomia/city/'+$route.params.ciudad">
            <div class="col-sm-12 cat-item res">
              <div class="tile"></div>
              <img src="../../assets/gastronomia-h.png" alt="" class="img-fluid">
            </div>
          </router-link>
          <router-link :to="'/directorio/lugares/city/'+$route.params.ciudad">
            <div class="col-sm-12 cat-item tour">
              <div class="tile"></div>
              <img src="../../assets/lugares-h.png" alt="" class="img-fluid">
            </div>
          </router-link>
          <router-link :to="'/directorio/nocturna/city/'+$route.params.ciudad">
            <div class="col-sm-12 cat-item noche">
              <div class="tile"></div>
              <img src="../../assets/nocturna-h.png" alt="" class="img-fluid">
            </div>
          </router-link>
          <div class="col-sm-12 cat-item">
            <!-- <img src="../../assets/turibus-h.png" alt="" class="img-fluid"> -->
          </div>
        </div>
        <div class="col-sm-9">
          <div class="col-sm-12">
            <city-nav/>
          </div>
          <div v-if="eventos">
            <div class="col-sm-12" v-for="lugar in eventos" :key="lugar.hash">
              <Card :data="lugar"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import http from '@/helpers/http'
import fondo from '@/assets/bg/nocturna.png'
import Card from '@/helpers/Card'
import CityNav from '@/helpers/CityNav'

export default {
  name: 'index',
  props: [],
  components: {
    CityNav,
    Card
  },
  mounted () {
    this.getEventos()
  },
  data () {
    return {
      fondo,
      cargando: true,
      eventos: []
    }
  },
  methods: {
    getEventos () {
      this.cargando = true
      this.eventos = []
      http.get('/eventos/' + this.$route.params.ciudad + '/city')
        .then(res => {
          this.eventos = res.data
          this.cargando = false
        }, err => {
          console.log(err)
        }, this)
    }
  },
  computed: {

  }
}
</script>

<style scoped lang="scss">
  .index {
    .titulo {
      padding: 35px;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center 40% !important;
      text-transform: uppercase;
      text-align: center;
      font-family: 'brandon_grotesque_regularRg', sans-serif;
    }
    .cats {
      .cat-item {
        padding: 20px;
        .tile {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background: -webkit-linear-gradient(
            135deg,
            rgba(148, 25, 167, 0.8) 0%,
            rgba(201, 48, 120, 0) 35%,
            rgba(201, 48, 120, 0) 65%,
            rgba(255, 72, 72, 0.8) 100%
          );
        }
        &.res {
          background: url("../../assets/bg2.png") no-repeat;
          background-size: cover;
        }
        &.tour {
          background: url("../../assets/bg3.png") no-repeat;
          background-size: cover;
        }
        &.noche {
          background: url("../../assets/bg4.png") no-repeat;
          background-size: cover;
        }
      }
    }
  }
</style>
